export enum DATA_QA {
  ROOT = 'archive-campaign',
  CANCEL = 'archive-campaign__cancel',
  CONFIRM = 'archive-campaign__confirm',
}
